import React, { useState } from 'react';
import { ChevronDown, Pencil, Send, Trash2, RotateCw, MessageSquare } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { CreativeBody, ObservationsList } from './AdsCreativeParts';
import { adsApprovalsAPI } from '../lib/api';

export const TeamCreativeRow = ({ c, idx, onEdit, onChanged }) => {
  const [open, setOpen] = useState(c.estado === 'cambios');
  const [reply, setReply] = useState('');
  const act = (p, msg) => p.then(() => { if (msg) toast.success(msg); onChanged(); }).catch((e) => toast.error(e.message));
  const editable = c.estado === 'borrador' || c.estado === 'cambios';

  return (
    <div className="rounded-lg border bg-background" data-testid={`team-creative-${c.id}`}>
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm" data-testid={`team-creative-toggle-${c.id}`}>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? '' : '-rotate-90'}`} />
        <span className="font-medium flex-1 truncate">{c.nombre}</span>
        <span className={`text-xs rounded-full px-2 py-0.5 ${{ borrador: 'bg-slate-100', pendiente: 'bg-amber-100 text-amber-800', aprobado: 'bg-emerald-100 text-emerald-800', cambios: 'bg-red-100 text-red-700' }[c.estado]}`}>
          {{ borrador: 'Borrador', pendiente: 'Pendiente', aprobado: 'Aprobado', cambios: 'Cambios solicitados' }[c.estado]}
        </span>
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-3 border-t pt-3">
          <CreativeBody c={c} idx={`t-${idx}`} />
          <ObservationsList items={c.observaciones} />
          <div className="flex flex-wrap gap-2">
            {editable && <Button size="sm" variant="outline" onClick={() => onEdit(c)} data-testid={`team-creative-edit-${c.id}`}><Pencil className="w-3.5 h-3.5 mr-1" />Editar</Button>}
            {c.estado === 'cambios' && <Button size="sm" onClick={() => act(adsApprovalsAPI.resendCreative(c.id), 'Reenviado al cliente')} data-testid={`team-creative-resend-${c.id}`}><RotateCw className="w-3.5 h-3.5 mr-1" />Reenviar a aprobación</Button>}
            {c.estado === 'borrador' && <Button size="sm" variant="ghost" onClick={() => window.confirm('¿Eliminar este creativo?') && act(adsApprovalsAPI.deleteCreative(c.id))} data-testid={`team-creative-delete-${c.id}`}><Trash2 className="w-3.5 h-3.5 text-red-600" /></Button>}
          </div>
          {c.estado !== 'borrador' && (
            <div className="flex gap-2">
              <Textarea value={reply} onChange={(e) => setReply(e.target.value)} rows={1} placeholder="Responder o añadir una nota al historial" className="min-h-[38px]" data-testid={`team-creative-reply-${c.id}`} />
              <Button size="sm" variant="secondary" disabled={!reply.trim()} onClick={() => act(adsApprovalsAPI.teamObservation(c.id, reply)).then(() => setReply(''))} data-testid={`team-creative-reply-btn-${c.id}`}><MessageSquare className="w-4 h-4" /></Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export const SendBatchButton = ({ batch, onChanged }) => (
  <Button size="sm" disabled={!batch.creatives.length} data-testid={`batch-send-${batch.id}`}
    onClick={() => window.confirm(`¿Enviar «${batch.nombre}» al cliente? Recibirá el aviso en Discord y en su portal.`)
      && adsApprovalsAPI.sendBatch(batch.id).then(() => { toast.success('Tanda enviada al cliente'); onChanged(); }).catch((e) => toast.error(e.message))}>
    <Send className="w-3.5 h-3.5 mr-1" />Enviar a aprobación
  </Button>
);
